import React, { useState, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components'
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'
import ReactLoading from 'react-loading';
import KPICard from '../components/Dashboard/KPIReportCard.js';

import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Map, { Source, Layer } from 'react-map-gl';

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';

import optc from '../optc.json'

import { reduceTotalValues } from '../helpers/routeOperationHelpers.js'

import {
  getDailyVehicleWork, getDailySingleVehWork,
  getAllAgencies, getUser, getPlannedTrips,
  getValuesPrevious, getPlanTripCumul, getUserAgency,
  getTripTrace, getTripPoints, getVehTripsInfo
} from '../API.js';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import { useTranslation } from "react-i18next";

const Styles = styled.div
  `
  padding: 1rem;

  .pagination {
    padding: 0.5rem;
  }

  th

  td { background-color: white; }

  td:nth-child(1) { 
    background: #79508f ;
    color: white }
  
`

function Table({ columns, data }) {

  const [t] = useTranslation('common');

  const [selectedRow, setSelectedRow] = useState(-1);

  const [filterInput, setFilterInput] = useState("");

  const handleFilterChange = e => {
    const value = e.target.value || undefined;
    setFilter("vehicle_id", value); // Update this specific field
    setFilterInput(value);
  };

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active pagconst [cellValue, setCellValue] = useState('');e

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },

      sortTypes: {
        custom: (rowA, rowB, columnId) => {
          const a = rowA.values[columnId];
          const b = rowB.values[columnId];

          if (!isNaN(Number(a)) && !isNaN(Number(b))) {
            return Number(a) - Number(b);
          }
          return a.localeCompare(b);
        }
      },

    },
    useFilters,
    useSortBy,
    usePagination,
  )

  const handleRowHover = (e) => {
    setSelectedRow(e.id);
  }

  const handleMouseOut = () => {
    setSelectedRow(-1);
  }


  // Render the UI for your table
  return (


    <>
      {!headerGroups[0].headers.find((e) => { return e.id == 'route_id' }) ? <div className="row">
        <div className="col-12 text-center">
          <input
            value={filterInput}
            onChange={handleFilterChange}
            placeholder={t("vehoperation.find")}
          />
        </div>
      </div > : ''}
      <table className="table" {...getTableProps()}>
        <thead style={{ textAlign: 'center' }}>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {

            prepareRow(row);

            return (
              <tr onMouseMove={(e) => handleRowHover(row)} onMouseOut={() => handleMouseOut()}
                {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td
                    style={{ backgroundColor: row.id == selectedRow && cell.column.Header !== 'Véhicule' ? '#D3D3D3' : '' }}
                    {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} {t('routeoperation.of')} {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | {t("routeoperation.go")} {' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 25, 50, 100].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              {t("routeoperation.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}


function VehicleDailyOperation() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const [vehicles, setVehicles] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: <p>{t('vehoperation.table.vehicle')}</p>,
        accessor: 'vehicle_id',
        Cell: props => (
          <div
            style={{ cursor: 'pointer' }}
            onClick={(e) => handleVehicleClick(e)}>
            {props.value}
          </div>
        ),
      },
      {
        Header: <div>{t('vehoperation.table.atrip1')}<br /><div>{t('vehoperation.table.atrip2')}</div></div>,
        accessor: 'realtripcount',
      },
      {
        Header: <div>{t('vehoperation.table.routes1')}<br /><div>{t('vehoperation.table.routes2')}</div></div>,
        accessor: 'routes',
      },
      {
        Header: <div>{t('vehoperation.table.pkm1')}<br /><div>{t('vehoperation.table.pkm2')}</div></div>,
        accessor: 'planneddist',
        Cell: props => <div> {(props.value).toFixed(0)} </div>
      },
      {
        Header: <div>{t('vehoperation.table.akm1')}<br /><div>{t('vehoperation.table.akm2')}</div></div>,
        accessor: 'realdist',
        Cell: props => <div> {(props.value).toFixed(0)} </div>
      },
      {
        Header: <div>{t('vehoperation.table.apkm1')}<br /><div>{t('vehoperation.table.apkm2')}</div></div>,
        accessor: 'kmpct',
        Cell: props => <div> {(props.value * 100).toFixed(0)}% </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('vehoperation.table.phrs1')}<br /><div>{t('vehoperation.table.phrs2')}</div></div>,
        accessor: 'plannedduration',
        Cell: props => <div> {(props.value).toFixed(1)} </div>
      },
      {
        Header: <div>{t('vehoperation.table.ahrs1')}<br /><div>{t('vehoperation.table.ahrs2')}</div></div>,
        accessor: 'realduration',
        Cell: props => <div> {(props.value).toFixed(1)} </div>
      },
      {
        Header: <div>{t('vehoperation.table.aphrs1')}<br /><div>{t('vehoperation.table.aphrs2')}</div></div>,
        accessor: 'durationpct',
        Cell: props => <div> {(props.value * 100).toFixed(0)}% </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('routeoperation.table2.otp1')}<br /><div>{t('routeoperation.table2.otp2')}</div></div>,
        accessor: 'otp',
        Cell: props => <div> {props.value ? (props.value).toFixed(0) + '%' : t('home.na')} </div>,
        sortType: "custom"
      },
    ],
    [vehicles]
  )


  const columns2 = useMemo(
    () => [
      {
        Header: <p>{t('routeoperation.table2.trip')}</p>,
        accessor: 'trip_id',
        Cell: props => {
          const { trip_id, route_id, vehicle_id, date, plannedstarttime, direction_id } = props.row.original; // Access both values
          return (
            <div style={{ cursor: 'pointer' }} onClick={() => handleTripClick(trip_id, route_id, vehicle_id, date, plannedstarttime, direction_id)}>
              {trip_id}
            </div>
          );
        },
      },
      {
        Header: <p>{t('routeoperation.date')}</p>,
        accessor: 'date',
        Cell: props => <div> {props.value ? dayjs(props.value).format('YYYY-MM-DD') : ''} </div>,
      },
      {
        Header: <p>{t('routeoperation.table2.veh')}</p>,
        accessor: 'vehicle_id',
      },
      {
        Header: <p>{t('vehoperation.table.block')}</p>,
        accessor: 'block_id',
      },
      {
        Header: <p>{t('routeoperation.table1.route')}</p>,
        accessor: 'route_id',
        Cell: props => <div>{props.value}</div>,
      },
      {
        Header: <p>Direction</p>,
        accessor: 'direction_id',
      },
      {
        Header: <div>{t('routeoperation.table2.pstart1')}<br /><div>{t('routeoperation.table2.pstart2')}</div></div>,
        accessor: 'plannedstarttime',
        Cell: props => <div> {props.value !== 'ND' ? new Date(props.value * 1000).toISOString().substring(11, 16) : 'ND'} </div>,
        sortType: "custom"
      },
      {
        Header: <div>{t('routeoperation.table2.astart1')}<br /><div>{t('routeoperation.table2.astart2')}</div></div>,
        accessor: 'realstarttime',
        Cell: props => <div> {props.value ? dayjs(props.value).format('HH:mm') : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.pdist1')}<br /><div>{t('routeoperation.table2.pdist2')}</div></div>,
        accessor: 'planneddist',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.adist1')}<br /><div>{t('routeoperation.table2.adist2')}</div></div>,
        accessor: 'realdist',
        Cell: props => <div> {props.value ? (props.value).toFixed(1) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.pl1')}<br /><div>{t('routeoperation.table2.pl2')}</div></div>,
        accessor: 'plannedduration',
        Cell: props => <div> {props.value ? new Date(props.value.toString().substring(0, 5) * 1000 * 60).toISOString().substring(11, 16) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.al1')}<br /><div>{t('routeoperation.table2.al2')}</div></div>,
        accessor: 'realduration',
        Cell: props => <div> {props.value ? new Date(props.value.toString().substring(0, 5) * 1000 * 60).toISOString().substring(11, 16) : ''} </div>,
      },
      {
        Header: <div>{t('vehoperation.table.occ1')}<br /><div>{t('vehoperation.table.occ2')}</div></div>,
        accessor: 'maxoccupancy',
        Cell: props => <div> {props.value ? parseFloat(props.value).toFixed(3) : ''} </div>,
      },
      {
        Header: <div>{t('routeoperation.table2.otp1')}<br /><div>{t('routeoperation.table2.otp2')}</div></div>,
        accessor: 'otp',
        Cell: props => <div> {props.value > 0 ? parseFloat(props.value).toFixed(0) + '%' : 0 + '%'} </div>,
      },
    ],
    []
  )


  const [vehicle, setVehicle] = useState('');
  const [trips, setTrips] = useState([]);
  const [tripClick, setTripClick] = useState('');
  const [vehTrip, setVehTrip] = useState('');
  const [dateTrip, setDateTrip] = useState('');
  const [tripStart, setTripStart] = useState('');
  const [tripRoute, setTripRoute] = useState('');
  const [tripDir, setTripDir] = useState('');
  const [inbound, setInbound] = useState('');

  const [showTrips, setShowTrips] = useState(false);

  const [traceGeom, setTraceGeom] = useState({ "type": "FeatureCollection", "features": [] });
  const [tracePoints, setTracePoints] = useState({ "type": "FeatureCollection", "features": [] });
  const [stopsGeom, setStopsGeom] = useState({ "type": "FeatureCollection", "features": [] });
  const [mapIsLoaded, setMapIsLoaded] = useState(false);
  const [zoomValue, setZoomValue] = useState(11);
  const mapRef = useRef();
  const [hoveredFeature, setHoveredFeature] = useState('');


  const [user, setUser] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');
  const [groupAgencies, setGroupAgencies] = useState('');
  const [loading, setLoading] = useState(0);

  const [reduced, setReduced] = useState('');
  const [planTrips, setPlanTrips] = useState('');
  const [planTripsCurrent, setPlanTripsCurrent] = useState('');
  const [planKms, setPlanKms] = useState('');
  const [planHours, setPlanHours] = useState('');
  const [realTrips, setRealTrips] = useState('');
  const [realKms, setRealKms] = useState('');
  const [realHours, setRealHours] = useState('');
  const [pctBar, setPctBar] = useState([]);

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKey1, setRefreshKey1] = useState(0);
  const [refreshKey2, setRefreshKey2] = useState(0);
  const [refreshKey3, setRefreshKey3] = useState(0);

  // const [refresh, setRefresh] = useState(0);

  const [initDate, setInitDate] = useState(dayjs().add(1, 'day').format('YYYY-MM-DD'));
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [startFormat, setStartFormat] = useState('');
  const [endFormat, setEndFormat] = useState('');

  const [vehClick, setVehClick] = useState('yes');

  useEffect(() => {
    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency()
      .then(response => {
        setGroupAgencies(response);
        setUserAgency(response);
        setInbound(optc.optc.find((e) => e.operateur == response).inOut[0]);
      })

  }, []);


  useEffect(() => {

    setLoading(1);

    if (startFormat == '' || startFormat == dayjs().format('YYYY-MM-DD')) {

      getDailyVehicleWork(agency, startFormat, endFormat)
        .then(response => {
          setVehicles(response);

          let dataReduced = reduceTotalValues(response)[0];

          setReduced(dataReduced);

          setRealTrips(dataReduced.realTrips);
          setRealKms(dataReduced.realKM.toFixed(0));
          setRealHours(dataReduced.realDuration.toFixed(0));

          setLoading(0);

          return Promise.all([
            dataReduced,
            getPlannedTrips(agency),
            getPlanTripCumul(agency)
          ]);
        })
        .then(([
          dataReduced,
          plannedTripsResponse,
          tripCumulResponse
        ]) => {

          setPlanTrips(plannedTripsResponse[0].sum);
          setPctBar([{
            name: 'trips',
            plan: plannedTripsResponse[0].sum,
            real: dataReduced.realTrips
          }]);

          setPlanTripsCurrent(tripCumulResponse[0].plantripcount);
          setPlanKms(tripCumulResponse[0].plandist);
          setPlanHours(tripCumulResponse[0].planduration);

        })

      setVehClick('yes');

    }

    else {
      //PREVIOUS DAYS
      let previous = 1;

      // if ((startFormat == endFormat) || (endFormat == '')) {
      //   setVehClick('yes')
      // } else {
      //   setVehClick('no')
      // }

      Promise.all([
        getDailyVehicleWork(agency, startFormat, endFormat, previous),
        getValuesPrevious(agency, startFormat, endFormat)
      ])
        .then(([vehicleResponse, valuesResponse]) => {
          setVehicles(vehicleResponse);

          setPlanTripsCurrent(valuesResponse[0].plannedtrips);
          setPlanKms(valuesResponse[0].plannedvehkms);
          setPlanHours(valuesResponse[0].plannedvehhours);
          setRealTrips(valuesResponse[0].rttrips);
          setRealKms(valuesResponse[0].rtvehkms);
          setRealHours(valuesResponse[0].rtvehhours);

          setLoading(0);

        })
        .catch(error => {
          // Handle error if any of the async operations fail
          console.error("Error:", error);
        });
    }

  }, [refreshKey]);


  useEffect(() => {
    if (vehicle !== '' && showTrips == true) {
      if (dayjs().format('YYYY-MM-DD') == dayjs(endDate).format('YYYY-MM-DD')) {
        getDailySingleVehWork(agency, startFormat, endFormat, vehicle)
          .then(response => {
            setTrips(response);
          })
        // getVehTripsInfo(agency, startFormat, vehicle)
        //   .then((response) => {
        //     console.log(response);
        //     setTrips(response);
        //     setLoading(0);
        //   })
      } else {
        let previous = 1;
        getDailySingleVehWork(agency, startFormat, endFormat, vehicle, previous)
          .then(response => {
            setTrips(response);
          })
      }
    }
  }, [refreshKey1]);


  useEffect(() => {

    if (tripClick) {

      setTraceGeom({ "type": "FeatureCollection", "features": [] });
      setTracePoints({ "type": "FeatureCollection", "features": [] });

      getTripTrace(agency, startFormat, tripClick, dateTrip)
        .then((response) => {
          setTraceGeom(response[0].jsonb_build_object);
        })
      getTripPoints(agency, startFormat, endFormat, tripClick, vehTrip, dateTrip)
        .then((response) => {
          setTracePoints(response[0].jsonb_build_object)
        })
    }

  }, [refreshKey2])


  useEffect(() => {
    zoomToLocation();
  }, [refreshKey3])


  function handleVehicleClick(e) {

    setShowTrips(true);
    setVehicle(e.target.innerHTML);
    setRefreshKey1(oldKey => oldKey + 1);

  }


  const handleTripClick = (trip_id, route_id, vehicle_id, date, start, dir) => {
    // setTraceGeom({ "type": "FeatureCollection", "features": [] });
    setTripClick(trip_id);
    setVehTrip(vehicle_id);
    setTripStart(start);
    setTripDir(dir);
    setTripRoute(route_id);
    setDateTrip(dayjs(date).format('YYYY-MM-DD'));
    setRefreshKey2(oldKey => oldKey + 1);
    setRefreshKey3(oldKey => oldKey + 1);
  }


  const handleAgencySelect = (e) => {
    setAgency(e.target.value);
    setRefreshKey(oldKey => oldKey + 1);
    setPlanTrips('');
    setPlanKms('');
    setPlanHours('');
    setRealTrips('');
    setRealKms('');
    setRealHours('');
  }

  const handleOnLoad = () => {
    setMapIsLoaded(true);
  }


  const handleChangeDate = (dates) => {

    const [start, end] = dates;

    if (dayjs(start).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')) {
      setInitDate(dayjs().format('YYYY-MM-DD'));
    }

    setStartDate(start);
    setEndDate(end);
    setEndFormat('');

    if (end !== null) {

      setLoading(1);

      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');

      setVehicle('');
      setVehClick(0);
      setTraceGeom({ "type": "FeatureCollection", "features": [] });
      setTracePoints({ "type": "FeatureCollection", "features": [] });

      setShowTrips(false);

      setStartFormat(formatstart);
      setEndFormat(formatend);
      setInitDate(dayjs().add(1, 'day').format('YYYY-MM-DD'));
      setRefreshKey(oldKey => oldKey + 1);
    }

  };


  const zoomToLocation = () => {
    if (mapIsLoaded == true && user !== 'admin') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[1],
          optc.optc.find((e) => e.operateur == userAgency[0]).latlong[0]
        ],
        duration: 2000,
        zoom: 9
      });
    } else if (mapIsLoaded == true && user == 'admin') {
      mapRef.current?.flyTo({
        center: [
          optc.optc.find((e) => e.operateur == agency).latlong[1],
          optc.optc.find((e) => e.operateur == agency).latlong[0]
        ],
        duration: 2000,
        zoom: 9
      });
    }

  }

  const onHover = event => {
    const feature = event.features?.find(f => f.layer.id === "stop-points");

    if (feature) {
      setHoveredFeature({
        feature: feature,
        x: event.point.x,
        y: event.point.y
      });
    } else {
      setHoverInfo(null);
    }
  };


  const onMouseOut = () => {
    setHoveredFeature(null);
  };


  const renderTooltip = () => {
    if (!hoveredFeature) return null;

    const { x, y, feature } = hoveredFeature;

    // Example: show the feature id or any property
    return (
      <div
        style={{
          position: "absolute",
          left: x,
          top: y,
          background: "white",
          padding: "4px 6px",
          pointerEvents: "none",
          borderRadius: 3,
          fontSize: 12,
          transform: "translate(10px, -10px)"
        }}
      >
        <div>{feature.properties?.time.split('.')[0] ?? "Point"}</div>
        <div>{feature.properties?.speed.toFixed(0) + ' km/h' ?? "Point"}</div>
      </div>
    );
  };


  return (

    user && vehicles && groupAgencies && pctBar.length > 0 ?

      <>
        <div className="row justify-content-center ps-1 pe-1">
          <h1 id="page-title" className="display-5">{t('vehoperation.title')}</h1>
          {Array.isArray(groupAgencies) && groupAgencies.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : groupAgencies[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          {loading == 0 ? '' :
            <div className="ponctualitetripspinner">
              <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
            </div>}

          <div className="d-flex justify-content-center pt-3 pb-2">
            <DatePicker
              selected={startDate}
              onChange={handleChangeDate}
              locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
              inline
              startDate={startDate}
              endDate={endDate}
              selectsRange
              excludeDateIntervals={[
                {
                  start: new Date('2000-01-01'),
                  end: new Date('2023-07-01')
                },
                {
                  start: new Date(initDate),
                  end: new Date('2030-12-31')
                },
              ]}
            />
          </div>

          {Array.isArray(groupAgencies) && groupAgencies.length > 1 ? <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-12">
              <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                <option defaultValue>Opérateur</option>
                {groupAgencies.map((e) => (
                  <option value={e} key={e}
                  >{e}</option>
                ))}
              </select>
            </div>
          </div> : ''}


          <div className="row justify-content-center">
            <div className="col text-center pt-3">
              <h3>{(startFormat == endFormat || endFormat == '') ?
                dayjs(startDate).format('YYYY-MM-DD') :
                t("datatable.from") + ' ' + dayjs(startDate).format('YYYY-MM-DD') + ' ' + t("datatable.to") + ' ' + dayjs(endDate).format('YYYY-MM-DD')}</h3>
              {/* <h5 className="display-7">Inclus les départs après minuit</h5> */}
            </div>
          </div>

          {(dayjs(startDate).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')) && (endDate !== null) ?
            <div className="row justify-content-center align-items-center progress-section">
              <div className="col-lg-6 col-sm-12 text-center">
                <div>{t("vehoperation.progress")}</div>
                <ResponsiveContainer width="100%" height={100}>
                  <BarChart
                    width={500}
                    height={300}
                    data={pctBar}
                    layout="vertical"
                    margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
                    barGap={-50}
                  >
                    <XAxis type="number" domain={[0, 'dataMax']} hide />
                    <YAxis type="category" hide />
                    {/* <Tooltip
                            content={<CustomTooltip />}
                          /> */}
                    <Bar dataKey="plan" fill="#ffffff" stroke="black" barSize={50} />
                    <Bar dataKey="real" fill="#a986bb" barSize={50} />
                    <text
                      x='50%'
                      y='45%'
                      dy={+12}
                      style={{ fontSize: 20, fill: '#000000' }}
                      width={200}
                      scaletofit="true"
                      textAnchor='middle'
                      verticalanchor='middle'
                    >
                      {realTrips + '/' + planTrips + ' (' + (realTrips / planTrips * 100).toFixed(0) + '%)'}
                    </text>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            : ''
          }

          {/* <div className="row no-gutters align-items-center justify-content-center"> */}
          <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 justify-content-center kpi-row-centered kpi-section-after-progress">
            <KPICard
              kpi={realTrips && planTripsCurrent ? parseFloat(realTrips / planTripsCurrent * 100).toFixed(1) + '%' : t('data.loading')}
              desc={<><div>{t("home.kpi.trips")}</div><div>{
                realTrips && planTripsCurrent ? realTrips + ' / ' + planTripsCurrent : t('data.loading')}</div></>}
            />
            <KPICard
              kpi={realKms && planKms ? parseFloat(realKms / planKms * 100).toFixed(1) + '%' : t('data.loading')}
              desc={<><div>{t("home.kpi.km")}</div>
                <div>{realKms && planKms ?
                  realKms + ' / ' + parseFloat(planKms).toFixed(0) : t('data.loading')}</div>
              </>}
            />
            <KPICard
              kpi={realHours && planHours ? parseFloat(realHours / planHours * 100).toFixed(1) + '%' : t('data.loading')}
              desc={<><div>{t("home.kpi.hours")}</div>
                <div>{realHours && planHours ?
                  realHours + ' / ' + parseFloat(planHours).toFixed(0) : t('data.loading')}</div></>}
            />
          </div>

          <div className="col pt-2 pb-2">
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container">
                <div className="row justify-content-center">
                  <div className="col">
                    <Styles>
                      <Table columns={columns} data={vehicles} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {vehicle !== '' && showTrips == true ? <div className="col pt-2 pb-2">
            <h3 className="text-center pt-2 pb-2">{t("vehoperation.table.vehicle")} {vehicle}</h3>
            <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
              <div id="overflow-table" className="container">
                <div className="row justify-content-center">
                  <div className="col">
                    <Styles>
                      <Table columns={columns2} data={trips} />
                    </Styles>
                  </div>
                </div>
              </div>
            </div>
          </div> : ''}

          <div className="row justify-content-center pt-3">
            <div className="col-lg-12 col-sm-12 pt-3 pb-4">
              <h3 className="text-center">{tripClick ? dateTrip + ' ' + t("routeoperation.route") + tripRoute
                + ' direction ' + (tripDir == inbound ? t('tripotp.in') : t('tripotp.out'))
                + ' ' + t('tripotp.at') + ' ' + new Date(tripStart * 1000).toISOString().substring(11, 16)
                + ' ' + t("routeoperation.table2.veh") + ' ' + vehicle : ''}</h3>
              <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                <Map
                  initialViewState={{
                    latitude: 45.556827,
                    longitude: -73.662362,
                    zoom: zoomValue
                  }}
                  style={{ width: '100%', height: '40vh' }}
                  ref={ref => mapRef.current = ref && ref.getMap()}
                  interactiveLayerIds={["stop-points"]}
                  onLoad={handleOnLoad}
                  onMouseEnter={onHover}
                  onMouseLeave={onMouseOut}
                  mapStyle="mapbox://styles/wdoucetk/cjun8whio1ha21fmzxt8knp7k"
                  mapboxAccessToken={process.env.REACT_APP_MAPBOX_KEY}
                  attributionControl={false}
                >

                  {renderTooltip()}
                  <Source
                    id={"stops"}
                    type="geojson" data={tripClick ? { "type": "FeatureCollection", "features": [] } : stopsGeom}
                  >
                    <Layer {...{
                      "id": "stops",
                      "type": "circle",
                      "source": "stops",
                      "paint": {
                        "circle-radius": 3,
                        "circle-color": "white",
                        "circle-stroke-width": 1,
                        "circle-stroke-color": user == 'admin' ?
                          optc.optc.find((e) => e.operateur == agency).color :
                          optc.optc.find((e) => e.operateur == userAgency[0]).color
                      }
                    }} />
                  </Source>
                  <Source
                    id={"points"}
                    type="geojson" data={tripClick ? tracePoints : { "type": "FeatureCollection", "features": [] }}
                  >
                    <Layer {...{
                      "id": "stop-points",
                      "type": "circle",
                      "source": "points",
                      "paint": {
                        "circle-radius": 3,
                        "circle-color": '#4d0077',
                        "circle-stroke-width": 1,
                        "circle-stroke-color": '#4d0077'
                      }
                    }} />
                  </Source>
                  <Source
                    id={"route_dir"}
                    type="geojson" data={tripClick ? traceGeom : { "type": "FeatureCollection", "features": [] }}
                  >
                    <Layer {...{
                      "beforeId": "stops",
                      "id": "trace",
                      'type': 'line',
                      "source": "route_dir",
                      "layout": {
                        "line-join": "round",
                        "line-cap": "round",
                        "visibility": "visible"
                      },
                      "paint": {
                        'line-width': 1,
                        'line-color': user == 'admin' ?
                          optc.optc.find((e) => e.operateur == agency).color :
                          optc.optc.find((e) => e.operateur == userAgency[0]).color
                      }
                    }} />
                  </Source>
                </Map>
              </div>
            </div>
          </div>

        </div>
      </> :
      <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="d-flex justify-content-center">
          <div className="row">
            <div className="col-sm">
              <h1 className="display-5">{t('data.loading')}</h1>
              <div className="d-flex justify-content-center">
                <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default VehicleDailyOperation;

